import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterSelect } from '@/shared/ui';
import { type AttachmentType } from '@/entities/consignments';

import { getAttachmentTypeLabelOptions } from '../model/types';

interface AttachmentTypeSelectProps {
  value: AttachmentType | null;
  onChange: (value: AttachmentType) => void;
  disabled?: boolean;
  /** Restricts the list — receipts reject `GO`, so their screens pass their own set. */
  allowedTypes?: AttachmentType[];
}

export function AttachmentTypeSelect({ value, onChange, disabled, allowedTypes }: AttachmentTypeSelectProps) {
  const { t } = useTranslation();
  const options = useMemo(() => {
    const all = getAttachmentTypeLabelOptions(t);
    if (!allowedTypes) return all;

    const allowed = new Set(allowedTypes);
    return all.filter((option) => allowed.has(option.value));
  }, [t, allowedTypes]);

  return (
    <FilterSelect
      label={t('onlinesrf.attachment.type.label')}
      value={value || undefined}
      onChange={onChange}
      options={options}
      placeholder={t('onlinesrf.attachment.type.placeholder')}
      width="full"
      disabled={disabled}
    />
  );
}
